import moment from 'moment'

const commonMixin = {

    methods: {
        onShowModal(modal) {
            this.$nextTick(() => {
                this.$refs[modal].show();
            });
        },

        closeModal(modal) {
            this.$nextTick(() => {
                this.$refs[modal].close();
            });
        },

        formatDate(date, format = 'DD.MM.YYYY') {
            if (date == undefined)
                return '';

            let d = moment(date);
            if (d.isValid()) {
                return d.format(format);
            }
            else {
                return '';
            }
        },

        formatDateFromUtcToLocal(date, format = 'DD.MM.YYYY') {
            if (date == undefined)
                return '';

            let d = moment.utc(date);
            if (d.isValid()) {
                return d.local().format(format);
            }
            else {
                return '';
            }
        },

        formatDateLong(date, format = 'DD.MM.YYYY HH:mm') {
            if (date == undefined)
                return '';

            let d = moment(date);
            if (d.isValid()) {
                return d.format(format);
            }
            else {
                return '';
            }
        },

        /**
         * добавляет десятичный разделитель (пробел) в int значение
         * @param val
         * @returns {string}
         */
        formatInt(val) {
            return ('' + val).replace(/(\d)(?=(\d\d\d)+([^\d]|$|\.))/g, '$1 ');
        },
        //текущий месяц на русском
        currentMonth: function () {
            var v = new Date().toLocaleString('ru', {
                year: 'numeric',
                month: 'long'
            });
            v = v.replace(' г.', '');
            v = v.charAt(0).toUpperCase() + v.substr(1);
            return v;
        },

        /**
         * замена разметки html элементами
         * @param val
         * @returns {string}
         */
        formatMarkdownLiteToHtml(val) {
            return (val + '')
                .replace(/(\*\*)([^\*]+)(\*\*)/ig, '<b>$2</b>')
                .replace(/(\-\-)([^\-]+)(\-\-)/ig, '<p class="p-header-1 margin-top-20">$2</p>')
                .replace(/(<\/p>)([^<]+)((<p class="p-header-1 margin-top-20">)|$)/ig, '$1<p class="caption-help">$2</p>$3');
        },

        //окончание текста с учетом количества
        get_text_ending: function (int, endArr) {
            //int - число для которого подбирается концовка
            //endArr - 3 варианта концовки, для 1, для 2-4, для 5-9 и 11-19
            let sEnding;
            int = int % 100;
            if (int >= 11 && int <= 19) {
                sEnding = endArr[2];
            }
            else {
                let i = int % 10;
                switch (i) {
                    case (1):
                        sEnding = endArr[0];
                        break;
                    case (2):
                    case (3):
                    case (4):
                        sEnding = endArr[1];
                        break;
                    default:
                        sEnding = endArr[2];
                        break;
                }
            }
            return sEnding;
        },

        /**
         * уникальный идентификатор вида a837179b-05d6-4dfb-bc6c-8aa5c3bfd8bd
         * https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
         */
        generateGuid: function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });

        },

        getPageTitle: function(path){
            if(!path){
                path = this.$route.path;
            }
            let title;
            if(this.info && this.info.Pages && this.info.Pages.find(x => x.Path === path)){
                title = this.info.Pages.find(x => x.Path === path).Name;
            } 

            if(!title) {
                switch (path) {
                    case '/':
                    case '/news':
                        title = 'Новости';
                        break;
                    case '/reports/0':
                    case '/reports/fns/0':
                        title = 'Новый отчёт';
                        break;
                    case '/materials':
                        title = 'Материалы';
                        break;
                    case '/sku':
                        title = 'SKU';
                        break;
                    case '/spend-bonuses':
                        title = 'Потратить бонусы';
                        break;
                    case '/cart':
                        title = 'Корзина';
                        break;
                    case '/rating':
                        title = 'Рейтинг';
                        break;
                    case '/analytics':
                        title = 'Аналитика';
                        break;
                    case '/faq':
                        title = 'Faq';
                        break;
                    case '/motivation':
                        title = 'Мотивация';
                        break;
                    case '/reports':
                        title = 'Отчёты';
                        break;
                    case '/orders':
                        title = 'Заказы';
                        break;
                    case '/sender':
                        title = 'Рассылка';
                        break;
                    case '/tasks':
                    case '/tasks/table':
                        title = 'Задания';
                        break;
                }
            }

            return title;
        },

        CommonMixin_UsersProcessFilter: function(filter){
            if(!filter){
                return null;
            }
            let filterCopy = JSON.parse(JSON.stringify(filter));
            let stateEnums = {
                '[dbo].[AspNetUsers].[TermsConfirmed]': {
                    'Да': 1,
                    'Нет': 0
                },
                '[dbo].[AspNetUsers].[PersonalDataEditingAccept]': {
                    'Да': 1,
                    'Нет': 0
                },
                '[dbo].[AspNetUsers].[NotificationsEnabled]': {
                    'Да': 1,
                    'Нет': 0
                },
                '[dbo].[AspNetUsers].[PassportVerificationState]': {
                    'документы отсутствуют': 0,
                    'проверь документы!': 1,
                    'документы подтверждены': 2,
                    'документы возвращены': 3
                },
                '[dbo].[AspNetUsers].[RegisterStatus]': {
                    'неактивен': 0,
                    'проверка': 1,
                    'активен': 2,
                    'отказано': 3,
                    'отключен': 4,
                    'заблокирован': 5
                }
            };

            let resultFilter = [];
            for (let item of filterCopy) {
                let filterField = item[0];
                let dontPushItem = false;
                if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]'
                    ||filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]'
                    || filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {

                    let values = item[2].substring(1, item[2].length - 1).split(';').map(x => decodeURI(x)).map(x => {
                        let name = x.substring(1, x.length - 1);
                        let state = stateEnums[filterField][name];
                        return state;
                    });

                    if (filterField === '[dbo].[AspNetUsers].[TermsConfirmed]' || filterField === '[dbo].[AspNetUsers].[PersonalDataEditingAccept]'
                        || filterField === '[dbo].[AspNetUsers].[NotificationsEnabled]' || filterField === '[dbo].[AspNetUsers].[PassportVerificationState]'
                        || filterField === '[dbo].[AspNetUsers].[RegisterStatus]') {

                        item[0] = `isnull(${filterField}%comma%0)`;

                        if(filterField === '[dbo].[AspNetUsers].[RegisterStatus]'){
                            let dateFilters = values.filter(x => x === 4 || x === 5 || x === 2);
                            let statusFilters = values.filter(x => x !== 4 && x !== 5 && x !== 2);

                            let dateFilterPart = '';
                            if(dateFilters.length) {
                                if (values.indexOf(4) > -1 && values.indexOf(5) === -1) {
                                    // только Отключен
                                    dateFilterPart = '[dbo].[AspNetUsers].[DisabledDateTime] <= getdate() and ([dbo].[AspNetUsers].[BlockedDateTime] is null or [dbo].[AspNetUsers].[BlockedDateTime] > getdate())';
                                }
                                if (values.indexOf(5) > -1 && values.indexOf(4) === -1) {
                                    // только Заблокирован
                                    dateFilterPart = '[dbo].[AspNetUsers].[BlockedDateTime] <= getdate()';
                                }
                                if (values.indexOf(5) > -1 && values.indexOf(4) > -1) {
                                    // оба фильтра
                                    dateFilterPart = '([dbo].[AspNetUsers].[DisabledDateTime] <= getdate() or [dbo].[AspNetUsers].[BlockedDateTime] <= getdate())';
                                }

                                // если есть фильтр "Активен"
                                if(values.indexOf(2) > -1 ){
                                    if(dateFilterPart){
                                        // если уже указаны фильтры Заблокирован или Отключен
                                        dateFilterPart = '( (' + dateFilterPart + ') or [dbo].[AspNetUsers].[RegisterStatus] = 2' + ')';
                                    }else{
                                        // только фильтр Активен
                                        dateFilterPart = '[dbo].[AspNetUsers].[RegisterStatus] = 2 and ([dbo].[AspNetUsers].[BlockedDateTime] is null or [dbo].[AspNetUsers].[BlockedDateTime] > getdate())' +
                                            'and ([dbo].[AspNetUsers].[DisabledDateTime] is null or [dbo].[AspNetUsers].[DisabledDateTime] > getdate())';
                                    }
                                }
                            }

                            if(statusFilters.length){
                                item[2] = '(' + values.filter(x => x !== 4 && x !== 5 && x !== 2).map(function (item) {
                                    return `${encodeURI(item)}`;
                                }).join(';') + ')';
                            }
                            else{
                                dontPushItem = true;
                            }

                            if(dateFilters.length && !statusFilters.length){
                                resultFilter.push(['','', dateFilterPart]);
                            }

                            if(dateFilters.length && statusFilters.length){
                                dontPushItem = true;

                                resultFilter.push(['','', '(' + item.join(' ') + ' or ' + dateFilterPart + ')']);
                            }

                        }else{
                            item[2] = '(' + values.map(function (item) {
                                return `${encodeURI(item)}`;
                            }).join(';') + ')';
                        }

                    }
                    else {
                        item[2] = '(' + values.map(function (item) {
                            return `'${encodeURI(item)}'`;
                        }).join(';') + ')';
                    }
                }

                if(filterField === '[dbo].[AspNetUsers].[UserRole]'){
                    item[0] = '[dbo].[DynamicRole]';
                }

                if(!dontPushItem) {
                    resultFilter.push(item);
                }
            }

            return resultFilter;
        },

        getUrlParameter: function(sParam) {
            var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                sURLVariables = sPageURL.split('&'),
                sParameterName,
                i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');

                if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                }
            }
        },

        CommonMixin_doubleRequestAnimationFrame: (callback) => {
            requestAnimationFrame(() => {
                requestAnimationFrame(callback);
            })
        }
    }
};

export default commonMixin;


// WEBPACK FOOTER //
// ./Content/src/helpers/common-mixin.js